import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import OrgStatsPage from '../Pages/Admin/OrgStatsPage';
import UsersProgressPage from '../Pages/Admin/UserProgressPage';
import LearningDataPage from '../Pages/Admin/LearningDataPage';
import AssessmentDataPage from '../Pages/Admin/AssessmentDataPage';
import PopularCoursesPage from '../Pages/Admin/PopularCoursesPage';
import AccountShowPage from './Admin/AccountShowPage';
import AccountCreatePage from './Admin/AccountCreatePage';
import AccountsPage from './Admin/AccountsPage';
import AccountPlaygroundPage from './Admin/AccountPlaygroundPage';
import ActionTriggersPage from '../Pages/Admin/ActionTriggersPage';
import GroupsPage from './Admin/GroupsPage';
import GroupBuilder from '../Groups/GroupBuilder/GroupBuilder';
import LearningPlansPage from './Admin/LearningPlansPage';
import LearningPlanBuilder from '../LearningPlanBuilder/LearningPlanBuilder';
import LoaderOverlay from '../LoaderOverlay/LoaderOverlay';
import UsersPage from './Admin/UsersPage';
import UserProfilePage from './Admin/UserProfilePage';
import TemplatesPage from '../Pages/Admin/TemplatesPage';
import TemplateEditPage from '../Pages/Admin/TemplateEditPage';
import AppHeader from '../Admin/AppHeader';
import SideBar from '../Admin/SideBar';
import PageContent from '../Admin/PageContent';
import AppFooter from '../Admin/AppFooter';
import PermissionsHelper from '../../libraries/permissionsHelper';

export default function App(props) {
	const [
		store
	] = useState(props);

	const {
		account: { public_id },
		user: { decoded_access_token: { permissions } }
	} = props;

	// console.log('permissions', permissions);

	const permissionHelper = new PermissionsHelper(permissions);

	return (
		<Router>
			<AppHeader
				public_id={public_id}
				user={store.user}
				permissionsHelper={permissionHelper}
				sign_out_endpoint={store.endpoints.sign_out_endpoint}
			/>
			<SideBar
				public_id={public_id}
				user={store.user}
				permissionsHelper={permissionHelper}
				endpoints={store.endpoints}
			/>
			<PageContent>
				<Routes>
					<Route
						path={`/admin/${public_id}/`}
						element={
							<OrgStatsPage
								login_stats_endpoint={store.endpoints.login_stats_endpoint}
								login_daily_endpoint={store.endpoints.login_daily_endpoint}
								learning_stats_endpoint={
									store.endpoints.learning_stats_endpoint
								}
								assessment_well_being_endpoint={
									store.endpoints.assessment_well_being_endpoint
								}
								assessment_abc_endpoint={
									store.endpoints.assessment_abc_endpoint
								}
								assessment_stats_endpoint={
									store.endpoints.assessment_stats_endpoint
								}
								export_datatable_endpoint={
									store.endpoints.export_datatable_endpoint
								}
								export_endpoint={store.endpoints.export_endpoint}
								report="org_stats"
							/>
						}
					/>
					<Route
						path={`/admin/${public_id}/reports`}
						element={
							<OrgStatsPage
								login_stats_endpoint={store.endpoints.login_stats_endpoint}
								login_daily_endpoint={store.endpoints.login_daily_endpoint}
								learning_stats_endpoint={
									store.endpoints.learning_stats_endpoint
								}
								assessment_well_being_endpoint={
									store.endpoints.assessment_well_being_endpoint
								}
								assessment_abc_endpoint={
									store.endpoints.assessment_abc_endpoint
								}
								assessment_stats_endpoint={
									store.endpoints.assessment_stats_endpoint
								}
								export_datatable_endpoint={
									store.endpoints.export_datatable_endpoint
								}
								export_endpoint={store.endpoints.export_endpoint}
								report="org_stats"
							/>
						}
					/>
					<Route
						path={`/admin/${public_id}/reports/org-stats`}
						element={
							<OrgStatsPage
								login_stats_endpoint={store.endpoints.login_stats_endpoint}
								login_daily_endpoint={store.endpoints.login_daily_endpoint}
								learning_stats_endpoint={
									store.endpoints.learning_stats_endpoint
								}
								assessment_well_being_endpoint={
									store.endpoints.assessment_well_being_endpoint
								}
								assessment_abc_endpoint={
									store.endpoints.assessment_abc_endpoint
								}
								assessment_stats_endpoint={
									store.endpoints.assessment_stats_endpoint
								}
								export_datatable_endpoint={
									store.endpoints.export_datatable_endpoint
								}
								export_endpoint={store.endpoints.export_endpoint}
								report="org_stats"
							/>
						}
					/>
					<Route
						path={`/admin/${public_id}/reports/user-progress`}
						element={
							<UsersProgressPage
								login_stats_endpoint={store.endpoints.login_stats_endpoint}
								export_datatable_endpoint={
									store.endpoints.export_datatable_endpoint
								}
								export_endpoint={store.endpoints.export_endpoint}
								report="user_progress"
							/>
						}
					/>
					<Route
						path={`/admin/${public_id}/reports/learning-data`}
						element={
							<LearningDataPage
								learning_stats_endpoint={
									store.endpoints.learning_stats_endpoint
								}
								assessment_well_being_endpoint={
									store.endpoints.assessment_well_being_endpoint
								}
								export_datatable_endpoint={
									store.endpoints.export_datatable_endpoint
								}
								export_endpoint={store.endpoints.export_endpoint}
								report="learning_data"
							/>
						}
					/>
					<Route
						path={`/admin/${public_id}/reports/assessment-data`}
						element={
							<AssessmentDataPage
								assessment_abc_endpoint={
									store.endpoints.assessment_abc_endpoint
								}
								assessment_stats_endpoint={
									store.endpoints.assessment_stats_endpoint
								}
								export_datatable_endpoint={
									store.endpoints.export_datatable_endpoint
								}
								export_endpoint={store.endpoints.export_endpoint}
								report="assessment_data"
							/>
						}
					/>
					<Route
						path={`/admin/${public_id}/reports/popular-courses`}
						element={
							<PopularCoursesPage
								export_datatable_endpoint={
									store.endpoints.export_datatable_endpoint
								}
								export_endpoint={store.endpoints.export_endpoint}
								report="popular_courses"
							/>
						}
					/>
					<Route
						path={`/admin/${public_id}/learning-plans`}
						element={
							<LearningPlansPage
								permissionsHelper={permissionHelper}
								public_id={public_id}
								learning_plan_create_endpoint={
									store.endpoints.learning_plan_create_endpoint
								}
								get_learning_plan_endpoint={
									store.endpoints.get_learning_plan_endpoint
								}
								update_learning_plan_endpoint={
									store.endpoints.update_learning_plan_endpoint
								}
								delete_learning_plan_endpoint={
									store.endpoints.delete_learning_plan_endpoint
								}
								learning_plans_list_endpoint={
									store.endpoints.learning_plans_list_endpoint
								}
								generate_learning_plan_template_id_endpoint={
									store.endpoints.generate_learning_plan_template_id_endpoint
								}
							/>
						}
					/>
					<Route
						path={store.endpoints.new_learning_plan_endpoint}
						element={
							<LearningPlanBuilder
								account={store.account}
								courses={store.courses}
								public_id={public_id}
								learning_plan_create_endpoint={
									store.endpoints.learning_plan_create_endpoint
								}
								generate_learning_plan_template_id_endpoint={
									store.endpoints.generate_learning_plan_template_id_endpoint
								}
							/>
						}
					/>
					<Route
						path={`admin/${public_id}/learning-plan/edit/:learning_plan_id`}
						element={
							<LearningPlanBuilder
								account={store.account}
								courses={store.courses}
								public_id={public_id}
								learning_plan_create_endpoint={
									store.endpoints.learning_plan_create_endpoint
								}
								learning_plan_update_endpoint={
									store.endpoints.update_learning_plan_endpoint
								}
								get_learning_plan_endpoint={
									store.endpoints.get_learning_plan_endpoint
								}
								generate_learning_plan_template_id_endpoint={
									store.endpoints.generate_learning_plan_template_id_endpoint
								}
							/>
						}
					/>
					<Route
						path={`/admin/${public_id}/accounts`}
						element={
							<AccountsPage
								permissionsHelper={permissionHelper}
								public_id={public_id}
								accounts_list_endpoint={store.endpoints.accounts_list_endpoint}
								get_account_endpoint={store.endpoints.get_account_endpoint}
								update_account_endpoint={
									store.endpoints.update_account_endpoint
								}
								iam_account_create_endpoint={
									store.endpoints.iam_account_create_endpoint
								}
								account_crud_api_key={store.account_crud_api_key}
							/>
						}
					/>
					<Route
						path={`/admin/${public_id}/accounts/create`}
						element={
							<AccountCreatePage
								iam_account_create_endpoint={
									store.endpoints.iam_account_create_endpoint
								}
							/>
						}
					/>
					<Route
						path={`/admin/${public_id}/accounts/:id`}
						element={<AccountShowPage account_endpoint={store.account} />}
					/>
					<Route
						path={`/admin/${public_id}/accounts/playground`}
						element={<AccountPlaygroundPage account_endpoint={store.account} />}
					/>
					<Route
						path={`/admin/${public_id}/users`}
						element={
							<UsersPage
								public_id={public_id}
								iam_get_user_profile_endpoint={
									store.endpoints.iam_get_user_profile_endpoint
								}
								iam_update_user_profile_endpoint={
									store.endpoints.iam_update_user_profile_endpoint
								}
								iam_get_users_endpoint={store.endpoints.iam_get_users_endpoint}
								iam_get_user_roles_endpoint={
									store.endpoints.iam_get_user_roles_endpoint
								}
								iam_send_invitations_endpoint={
									store.endpoints.iam_send_invitations_endpoint
								}
								users_stats_endpoint={store.endpoints.users_stats_endpoint}
								permissionsHelper={permissionHelper}
							/>
						}
					/>
					<Route
						path={`/admin/${public_id}/users/:id`}
						element={
							<UserProfilePage
								courses={store.courses}
								iam_to_cdx_user_mapping_endpoint={
									store.endpoints.iam_to_cdx_user_mapping_endpoint
								}
								iam_get_user_summary_endpoint={
									store.endpoints.iam_get_user_summary_endpoint
								}
								iam_get_user_personal_endpoint={
									store.endpoints.iam_get_user_personal_endpoint
								}
								iam_get_user_custom_endpoint={
									store.endpoints.iam_get_user_custom_endpoint
								}
								iam_get_user_login_endpoint={
									store.endpoints.iam_get_user_login_endpoint
								}
								iam_get_user_roles_endpoint={
									store.endpoints.iam_get_user_roles_endpoint
								}
								iam_update_is_reportable_endpoint={
									store.endpoints.iam_update_is_reportable_endpoint
								}
								iam_update_user_roles_endpoint={
									store.endpoints.iam_update_user_roles_endpoint
								}
								iam_update_user_profile_endpoint={
									store.endpoints.iam_update_user_profile_endpoint
								}
								user_learning_plans_endpoint={
									store.endpoints.user_learning_plans_endpoint
								}
								lock_unlock_assessment_endpoint={
									store.endpoints.lock_unlock_assessment_endpoint
								}
								score_released_assessment_endpoint={
									store.endpoints.score_released_assessment_endpoint
								}
								save_personal_data_endpoint={
									store.endpoints.save_personal_data_endpoint
								}
								get_assessments_by_user_endpoint={
									store.endpoints.get_assessments_by_user_endpoint
								}
								permissionsHelper={permissionHelper}
							/>
						}
					/>
					<Route
						path={`/admin/${public_id}/groups`}
						element={
							<GroupsPage
								public_id={public_id}
								iam_create_group_endpoint={
									store.endpoints.iam_create_group_endpoint
								}
								iam_get_group_endpoint={store.endpoints.iam_get_group_endpoint}
								iam_update_group_endpoint={
									store.endpoints.iam_update_group_endpoint
								}
								iam_delete_group_endpoint={
									store.endpoints.iam_delete_group_endpoint
								}
								iam_get_groups_endpoint={
									store.endpoints.iam_get_groups_endpoint
								}
							/>
						}
					/>
					<Route
						path={`admin/${public_id}/groups/edit/:group_id`}
						element={
							<GroupBuilder
								account={store.account}
								iam_get_group_endpoint={store.endpoints.iam_get_group_endpoint}
								iam_update_group_endpoint={
									store.endpoints.iam_update_group_endpoint
								}
								iam_users_remote_endpoint={
									store.endpoints.iam_users_remote_endpoint
								}
								iam_get_members_endpoint={
									store.endpoints.iam_get_members_endpoint
								}
								iam_add_member_endpoint={
									store.endpoints.iam_add_member_endpoint
								}
								iam_remove_member_endpoint={
									store.endpoints.iam_remove_member_endpoint
								}
								iam_get_restrictions_endpoint={
									store.endpoints.iam_get_restrictions_endpoint
								}
								iam_add_restriction_endpoint={
									store.endpoints.iam_add_restriction_endpoint
								}
								iam_remove_restriction_endpoint={
									store.endpoints.iam_remove_restriction_endpoint
								}
							/>
						}
					/>
					<Route
						path={`/admin/${public_id}/communications/templates`}
						element={
							<TemplatesPage
								get_communication_template_endpoint={
									store.endpoints.get_communication_template_endpoint
								}
								communication_templates_list_endpoint={
									store.endpoints.communication_templates_list_endpoint
								}
							/>
						}
					/>
					<Route
						path={`/admin/${public_id}/communications/templates/1`}
						element={<TemplateEditPage {...store} />}
					/>
					<Route
						path={`/admin/${public_id}/action-triggers`}
						element={
							<ActionTriggersPage
								create_action_trigger_endpoint={
									store.endpoints.create_action_trigger_endpoint
								}
								get_action_trigger_endpoint={
									store.endpoints.get_action_trigger_endpoint
								}
								update_action_trigger_endpoint={
									store.endpoints.update_action_trigger_endpoint
								}
								delete_action_trigger_endpoint={
									store.endpoints.delete_action_trigger_endpoint
								}
								action_triggers_list_endpoint={
									store.endpoints.action_triggers_list_endpoint
								}
							/>
						}
					/>
				</Routes>
			</PageContent>
			<AppFooter />
		</Router>
	);
}
